export default __webpack_public_path__ + "static/media/btechHeroImage.6f79cbe8.png";